(function () {
    "use strict";

    var CurrencyPairSelectorControl = Solovis.defineClass(
        "Solovis.InvDataSelectors.CurrencyPairSelectorControl",
        Solovis.UI.BaseControl,
        function (options) {
            // selectionCallback should be a function that takes an item.
            this._selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this._cancelCallback = options.cancelCallback ? options.cancelCallback : null;
            this._selectedCurrencyPair = options.initialValue ? options.initialValue : null;

            this._currencyPairList = [];
        });

    CurrencyPairSelectorControl.prototype.doInitAsync = function () {
        var self = this;
        (Solovis as any).Reports.ReportDataLoader.loadDataSetAsync("/Solovis/Metadata/ModelEnvironment", 
            { currencyOptions: { loadAll: true } },
            function (response, success) {
                if (success) {
                    var modelEnv = new InvData.ModelEnvironment();
                    modelEnv.mergeEnvironmentData(response.result.dataSet.modelEnvironment);

                    self._modelEnvironment = modelEnv;
                }

                self.notifyInitComplete();
            });
    };

    CurrencyPairSelectorControl.prototype.setAvailableHeight = function (overallHeight) {
        var self = this;

        if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
            this._filterListControl.setAvailableHeight(overallHeight);
        }
        else {
            // The control is still rendering, so we will store the overallHeight and defer until the render is complete
            this._availableHeight = overallHeight;
        }
    };

    CurrencyPairSelectorControl.prototype.doRender = function() {
        var self = this;

        var unsortedCurrencyPairList = [];

        $(self._modelEnvironment.currencyPairs.itemList).each(function(i, currencyPair: any) {
            var baseCurrency = self._modelEnvironment.currencies.tryGetById(currencyPair.baseCurrencyId);
            var quoteCurrency = self._modelEnvironment.currencies.tryGetById(currencyPair.quoteCurrencyId);

            var item = {
                id: currencyPair.id,
                baseCurrencyId: currencyPair.baseCurrencyId,
                quoteCurrencyId: currencyPair.quoteCurrencyId,
                label: baseCurrency.code + "/" + quoteCurrency.code
            };

            unsortedCurrencyPairList.push(item);
        });

        function compare(a, b) {

            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }

            return 0;
        }

        self._currencyPairList = unsortedCurrencyPairList.sort(compare);

        var selectorControlHostDiv = $("<div>")
            .addClass("solovis-input")
            .appendTo(this.container);

        this._filterListControl = new Solovis.UI.StringFilterListControl({
            controlHost: selectorControlHostDiv,
            listItems: this._currencyPairList,
            selectedItem: self._selectedCurrencyPair
        });

        $(this._filterListControl)
            .on("selectionChanged", function() {
                var selectedItem = self._filterListControl.getSelectedItem();
                self._selectionCallback(selectedItem);
            });

        this._filterListControl.setAsCurrentControl();

        this._filterListControl.focusFilter();

        if (this._availableHeight) {
            this._filterListControl.setAvailableHeight(this._availableHeight);
            this._availableHeight = null;
        }
        this._filterListControl.scrollToSelectedItem();
    };

    CurrencyPairSelectorControl.prototype.focus = function () {
        if (this.searchBox) {
            this.searchBox.focus();
        }
    };

})();